//process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0';
import { ResponseMapper, ResponseMapperImpl } from "./response/responsemapper";
import { Logger, LogManager } from "../logger/logger";
import * as https from 'https';
import { BaseContext } from '../basecontext';
import { Strings } from '../resources/strings';
import { HttpClient, HttpClientCredendtial, HttpClientHandler } from "./httpclient";
//import { AxiosError } from 'axios'


let axios = require('axios');

export class FlashMessageHttpClientImpl implements HttpClient
{
    private logger: Logger = LogManager.getLogger(FlashMessageHttpClientImpl.name);
    private httpRequest: any;
    private context: BaseContext;

    private httpClientHandler: HttpClientHandler;

    constructor()
    {
        this.logger.log("FlashMessageHttpClientImpl() invoked");
    }

    setHttpClientHandler(httpClientHandler: HttpClientHandler): void 
    {
       
        this.httpClientHandler = httpClientHandler;
    }

    createRequest(context: BaseContext, request: any, httpClientCredential: HttpClientCredendtial): HttpClient
    {
        this.context = context;
        // let MWUrl = "";
        // if(httpClientCredential.getAPIURL() === "settings")
        // {
        //     MWUrl = "http://localhost:8000/en/app-settings.json";
        // }
        // else if(httpClientCredential.getAPIURL() === "https://callertunes.etisalat.ae/en/en/ENG/faq_iosformat.json")
        // {
        //     MWUrl = "http://localhost:8000/en/en/ENG/faq_iosformat.json";
        // }
        // else
        // {
        //     MWUrl =  httpClientCredential.getAPIURL();
        // }

        this.logger.log("URL: " + httpClientCredential.getBASEURL());
        this.logger.log("Request: " + request);
        this.logger.log("Headers: " + JSON.stringify(httpClientCredential.getHttpHeaders()));

        
        this.httpRequest = axios(
            {
                method: httpClientCredential.getHttpMethod(),  
                headers: httpClientCredential.getHttpHeaders(),
                url: httpClientCredential.getBASEURL(),
                params: httpClientCredential.getQueryParams(),
                data: request,
                crossDomain: true,
                 strictSSL: false,
                httpsAgent: new https.Agent({  
                    rejectUnauthorized: true,
                ca: process.env.REACT_APP_CA_CERT,
                cert: process.env.REACT_APP_CERT,
                key: process.env.REACT_APP_KEY
                })
            }
            );
            
        this.logger.log("httpRequest: " + this.httpRequest);

        return this;
    }

    execute(): void
    {   
 
         this.httpRequest
        .then((response:any) => 
        {   
            let data = JSON.parse(JSON.stringify(response)).data;

            let responseMapper = this.getResponseMapper();
            responseMapper.setStatusCodeOutside(data.respCode);
            responseMapper.setResponseMap(data);
            responseMapper.setStatusCode(response.status);
            responseMapper.setStatusMsg(data.message);

            this.logger.log("Response: " + JSON.stringify(responseMapper.getResponseMap()));

            this.httpClientHandler.onSuccess(responseMapper);
        })
        .catch((error:any) => 
        {
            this.logger.error("Error : " + JSON.stringify(error.response));
            this.logger.error("Exception occurred in execute: " + error.message);

            // this.logger.error(error.stack);

            let responseMapper = this.getResponseMapper();

            if(error.response)
            {
                let data = JSON.parse(JSON.stringify(error.response)).data;
                if(data.responseMap !== undefined && data.responseMap !== null &&
                    data.responseMap.respDesc !== undefined && data.responseMap.respDesc !== null)
                    {
                    responseMapper.setStatusMsg(data.responseMap.respDesc);
                }
                else if(data.message !== undefined && data.message !== null)
                {
                    console.log("-----data.message: " + data.message);
                    responseMapper.setStatusMsg(data.message);
                }
                else
                {
                    responseMapper.setStatusMsg(this.context.getResources().getString(Strings.internal_server_error));
                }
                responseMapper.setStatusCode(error.response.status);
                responseMapper.setResponseMap(error.response);
            }
            else
            {
                responseMapper.setStatusCode("-1");
                responseMapper.setStatusMsg(error.message);
            }

            this.httpClientHandler.onFailure(responseMapper);
        });
    }

    protected getResponseMapper(): ResponseMapper
    {
        return new ResponseMapperImpl();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/httpclient/flashmessagehttpclient.tsx